import React, { useState, useEffect } from "react";

import {
  CCol,
  CRow,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText
} from "@coreui/react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Label } from "reactstrap";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const StatisticsAccessFilter = props => {
  const activeRole = useSelector(state => state.general.active_roles);
  const token = useSelector(state => state.user.token);

  const [groups, setGroups] = useState([{ id: 0, name: "Carregando" }]);
  const [regions, setRegions] = useState([{ id: 0, name: "Carregando" }]);
  const [schools, setSchools] = useState([{ id: 0, name: "Carregando" }]);
  const [rooms, setRooms] = useState([{ id: 0, name: "Carregando" }]);
  const [roles, setRoles] = useState([{ id: 0, name: "Carregando" }]);
  const [teachers, setTeachers] = useState([{ id: 0, name: "Carregando" }]);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [roleId, setRoleId] = useState([0]);

  const [teacherId, setTeacherId] = useState(0);
  const [teacherName, setTeacherName] = useState("Desconhecido");

  useEffect(() => {
    (async () => {
      let currentGroup = 0;
      let currentRegion = 0;
      let currentSchool = 0;
      let currentRoom = 0;
      let currentRole = 0;

      let currentGroups = [];
      let currentRegions = [];
      let currentSchools = [];
      let currentRooms = [];
      let currentRoles = [0];

      setGroups([{ id: 0, name: "Carregando" }]);
      setRegions([{ id: 0, name: "Carregando" }]);
      setSchools([{ id: 0, name: "Carregando" }]);
      setRooms([{ id: 0, name: "Carregando" }]);
      setRoles([{ id: 0, name: "Carregando" }]);

      if (activeRole.group_id) {
        currentGroups = [
          { id: activeRole.group_id, name: activeRole.group_name }
        ];
        currentGroup = activeRole.group_id;
      } else {
        const res = await axios
          .get(`${URL.api}access/group/list`, {
            headers: { authorization: `Bearer ${token}` }
          })
          .catch();
        const allGroups = res.data.data.map(group => ({
          id: group.id,
          name: group.name
        }));

        currentGroups = allGroups;
        currentGroup = allGroups[0].id;
      }

      if (activeRole.region_id) {
        currentRegions = [
          { id: activeRole.region_id, name: activeRole.region_name }
        ];
        currentRegion = activeRole.region_id;
      } else if (currentGroup) {
        const res = await axios
          .get(`${URL.api}access/region/listRegionFilter/${currentGroup}`, {
            headers: { authorization: `Bearer ${token}` }
          })
          .catch();

        currentRegions = [
          { id: 0, name: "Todas" },
          ...res.data.data.map(region => ({ id: region.id, name: region.name }))
        ];
        currentRegion = 0;
      } else {
        currentRegions = [{ id: 0, name: "Todas" }];
        currentRegion = 0;
      }

      if (activeRole.school_id) {
        currentSchools = [
          { id: activeRole.school_id, name: activeRole.school_name }
        ];
        currentSchool = activeRole.school_id;
      } else if (currentRegion) {
        const res = await axios
          .get(
            `${URL.api}access/school/listSchoolFilter/${currentGroup}/${currentRegion}`,
            { headers: { authorization: `Bearer ${token}` } }
          )
          .catch();

        currentSchools = [
          { id: 0, name: "Todas" },
          ...res.data.data.map(school => ({ id: school.id, name: school.name }))
        ];
        currentSchool = 0;
      } else {
        currentSchools = [{ id: 0, name: "Todas" }];
        currentSchool = 0;
      }

      if (currentSchool) {
        const res = await axios
          .get(
            `${URL.api}community/room/list?group[]=${currentGroup}&region[]=${currentRegion}&school[]=${currentSchool}&class=true`,
            { headers: { authorization: `Bearer ${token}` } }
          )
          .catch();

        let listRooms = [];
        let teacherId = props.user?.user?.id;

        let isTeacherInCurrentSchool = props.user?.user_roles.some(item => {
          if (item.school_id === currentSchool) {
            return item.role_id === 6;
          }
        });

        if (props.isDailyMode && isTeacherInCurrentSchool) {
          res.data.data.forEach(room => {
            room.room_teachers.forEach(infoTeacher => {
              if (infoTeacher.user_id === teacherId) {
                listRooms.push(room);
                setTeacherName(infoTeacher.teacher_name);
              }
            });
          });

          setTeacherId(teacherId);
        } else {
          listRooms = [...res.data.data];
        }

        currentRooms = [
          { id: 0, name: "Todas" },
          ...listRooms.map(room => ({ id: room.id, name: room.name }))
        ];
        currentRoom = props.isEditMode ? props.infoView.room_id : 0;
      } else {
        currentRooms = [{ id: 0, name: "Todas" }];
        currentRoom = 0;
      }

      const resRoles = await axios
        .get(`${URL.api}access/role/list`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .catch();

      currentRoles = [
        { id: 0, name: "Todos" },
        ...resRoles.data.data
          .filter(
            item =>
              ["G", "U", "R", "E", "P", "A", "S", "V"].indexOf(item.type) >
              ["G", "U", "R", "E", "P", "A", "S", "V"].indexOf(activeRole.type)
          )
          .map(role => ({ id: role.id, name: role.name }))
      ];
      currentRole = 0;

      const updateValues = values => {
        setGroups(values.groupsValue);
        setRegions(values.regionsValue);
        setSchools(values.schoolsValue);
        setRooms(values.roomsValue);
        setRoles(values.rolesValue);

        setGroupId(values.groupValue);
        setRegionId(values.regionValue);
        setSchoolId(values.schoolValue);
        setRoomId(values.roomValue);
        setRoleId(values.roleValue);

        props.onChange({
          groupId: values.groupValue,
          regionId: values.regionValue,
          schoolId: values.schoolValue,
          roomId: values.roomValue,
          roleId: values.roleValue
        });
      };

      updateValues({
        groupsValue: currentGroups,
        regionsValue: currentRegions,
        schoolsValue: currentSchools,
        roomsValue: currentRooms,
        rolesValue: currentRoles,
        groupValue: currentGroup,
        regionValue: currentRegion,
        schoolValue: currentSchool,
        roomValue: currentRoom,
        roleValue: currentRole
      });
    })();

    if (props.isEditMode) {
      setTeacherId(props.infoView.teacher_id);
    }
  }, []);

  useEffect(() => {
    let id = roomId; // id da turma
    if (id !== 0) {
      axios
        .get(`${URL.api}community/room/singleView/${id}`, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          let users = resp.data.data.room_user;
          let arrTeachers = [
            {
              name: "Desconhecido",
              id: 0
            }
          ];
          users.forEach(item => {
            if (item.role_id === 6) {
              let obj = {
                name: item.user_name,
                id: item.user_id
              };
              arrTeachers.push(obj);
            }
          });
          setTeachers(arrTeachers);
        });
    }
  }, [roomId]);

  useEffect(() => {
    if (props.getInfoSelectors) {
      props.getInfoSelectors(groupId, regionId, schoolId, roomId, teacherId);
    }
  }, [groupId, regionId, schoolId, roomId, teacherId]);

  const changeGroup = async newGroupId => {
    setGroupId(newGroupId);

    setRegions([{ id: 0, name: "Carregando" }]);
    setSchools([{ id: 0, name: "Carregando" }]);
    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(`${URL.api}access/region/listRegionFilter/${newGroupId}`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .catch();

    setRegions([
      { id: 0, name: "Todas" },
      ...res.data.data.map(region => ({ id: region.id, name: region.name }))
    ]);
    setRegionId(0);

    setSchools([{ id: 0, name: "Todas" }]);
    setSchoolId(0);

    setRooms([{ id: 0, name: "Todas" }]);
    setRoomId(0);

    props.onChange({
      groupId: newGroupId,
      regionId: 0,
      schoolId: 0,
      roomId: 0,
      roleId
    });
  };

  const changeRegion = async newRegionId => {
    setRegionId(newRegionId);

    setSchools([{ id: 0, name: "Carregando" }]);
    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(
        `${URL.api}access/school/listSchoolFilter/${groupId}/${newRegionId}`,
        { headers: { authorization: `Bearer ${token}` } }
      )
      .catch();

    setSchools([
      { id: 0, name: "Todas" },
      ...res.data.data.map(school => ({ id: school.id, name: school.name }))
    ]);
    setSchoolId(0);

    setRooms([{ id: 0, name: "Todas" }]);
    setRoomId(0);

    props.onChange({
      groupId,
      regionId: newRegionId,
      schoolId: 0,
      roomId: 0,
      roleId
    });
  };

  const changeSchool = async newSchoolId => {
    setSchoolId(newSchoolId);

    setRooms([{ id: 0, name: "Carregando" }]);

    const res = await axios
      .get(
        `${URL.api}community/room/list?group[]=${groupId}&region[]=${regionId}&school[]=${newSchoolId}&class=true`,
        { headers: { authorization: `Bearer ${token}` } }
      )
      .catch();

    setRooms([
      { id: 0, name: "Todas" },
      ...res.data.data.map(room => ({ id: room.id, name: room.name }))
    ]);
    setRoomId(0);

    props.onChange({
      groupId,
      regionId,
      schoolId: newSchoolId,
      roomId: 0,
      roleId
    });
  };

  const changeRoom = newRoomId => {
    setRoomId(newRoomId);

    props.onChange({
      groupId,
      regionId,
      schoolId,
      roomId: newRoomId,
      roleId
    });
  };
  const [selectedRoles, setSelectedRoles] = useState([
    { label: "Todos", value: 0 }
  ]);
  const changeRole = roles => {
    const newRolesIds = roles.map(e => e.value);
    const lastNewRole = newRolesIds[newRolesIds.length - 1];

    if (lastNewRole === 0) {
      roles = [{ label: "Todos", value: 0 }];
      setSelectedRoles(roles);
    } else {
      roles = roles.filter(e => e.value !== 0);
      setSelectedRoles(roles);
    }
    const definedRolesIds = roles.map(e => e.value);

    setRoleId(JSON.stringify(definedRolesIds));
    props.onChange({
      groupId,
      regionId,
      schoolId,
      roomId,
      roleId: JSON.stringify(definedRolesIds)
    });
  };

  const changeTeacher = newTeacherId => {
    setTeacherId(newTeacherId);

    props.onChange({
      groupId,
      regionId,
      schoolId,
      roomId,
      roleId,
      teacherId: newTeacherId
    });
  };

  return (
    <CRow className="mb-4" style={{ width: "100%" }}>
      <CCol style={{ maxWidth: "50%" }}>
        <div className="w-100 text-ellipsis">
          <Label className="d-block w-100 text-ellipsis">Grupo</Label>
        </div>
        <CInputGroup>
          <CInputGroupPrepend>
            <CInputGroupText>
              <i className="fa fa-wrench"></i>
            </CInputGroupText>
          </CInputGroupPrepend>
          <CSelect
            value={groupId}
            onChange={e => changeGroup(parseInt(e.target.value))}
            disabled={!!activeRole.group_id || props.viewOfflineRegister}
          >
            {props.viewOfflineRegister === true ? (
              <option>{props.infoView && props.infoView.group_name}</option>
            ) : (
              groups.map(item => <option value={item.id}>{item.name}</option>)
            )}
          </CSelect>
        </CInputGroup>
      </CCol>
      <CCol style={{ maxWidth: "50%" }}>
        <div className="w-100 text-ellipsis">
          <Label className="d-block w-100 text-ellipsis">Região</Label>
        </div>
        <CInputGroup>
          <CInputGroupPrepend>
            <CInputGroupText>
              <i className="fa fa-globe"></i>
            </CInputGroupText>
          </CInputGroupPrepend>
          <CSelect
            value={props.isEditMode ? props.infoView.region_id : regionId}
            onChange={e => changeRegion(parseInt(e.target.value))}
            disabled={!!activeRole.region_id || props.viewOfflineRegister}
          >
            {props.viewOfflineRegister === true ? (
              <option>{props.infoView && props.infoView.region_name}</option>
            ) : (
              regions.map(item => <option value={item.id}>{item.name}</option>)
            )}
          </CSelect>
        </CInputGroup>
      </CCol>
      <CCol style={{ maxWidth: "50%" }}>
        <div className="w-100 text-ellipsis">
          <Label className="d-block w-100 text-ellipsis">Escola</Label>
        </div>
        <CInputGroup>
          <CInputGroupPrepend>
            <CInputGroupText>
              <i className="fa fa-institution"></i>
            </CInputGroupText>
          </CInputGroupPrepend>
          <CSelect
            value={schoolId}
            onChange={e => changeSchool(parseInt(e.target.value))}
            disabled={!!activeRole.school_id || props.viewOfflineRegister}
          >
            {props.viewOfflineRegister === true ? (
              <option>{props.infoView && props.infoView.school_name}</option>
            ) : (
              schools.map(item => <option value={item.id}>{item.name}</option>)
            )}
          </CSelect>
        </CInputGroup>
      </CCol>
      <CCol style={{ maxWidth: "50%" }}>
        <div className="w-100 text-ellipsis">
          <Label className="d-block w-100 text-ellipsis">Turma</Label>
        </div>
        <CInputGroup>
          <CInputGroupPrepend>
            <CInputGroupText>
              <i className="fa fa-graduation-cap"></i>
            </CInputGroupText>
          </CInputGroupPrepend>
          <CSelect
            value={roomId}
            onChange={e => changeRoom(parseInt(e.target.value))}
            disabled={props.viewOfflineRegister}
          >
            {props.viewOfflineRegister === true ? (
              <option>{props.infoView && props.infoView.room_name}</option>
            ) : (
              rooms.map(item => <option value={item.id}>{item.name}</option>)
            )}
          </CSelect>
        </CInputGroup>
      </CCol>
      {props.isOfflineRegister && !props.hideTeacher && (
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Professor</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-graduation-cap"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <CSelect
              value={teacherId}
              onChange={e => changeTeacher(parseInt(e.target.value))}
              disabled={props.viewOfflineRegister}
            >
              {props.viewOfflineRegister === true ? (
                <option>
                  {props.infoView && props.infoView.teacher_name !== null
                    ? props.infoView.teacher_name
                    : "Desconhecido"}
                </option>
              ) : props.isDailyMode ? (
                <option value={teacherId}>{teacherName}</option>
              ) : (
                teachers.map(item => (
                  <option value={item.id}>{item.name}</option>
                ))
              )}
            </CSelect>
          </CInputGroup>
        </CCol>
      )}
      {!props.isOfflineRegister && !props.isEmotionMode && (
        <CCol style={{ maxWidth: "50%" }}>
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Perfil</Label>
          </div>
          <CInputGroup>
            <CInputGroupPrepend>
              <CInputGroupText>
                <i className="fa fa-graduation-cap"></i>
              </CInputGroupText>
            </CInputGroupPrepend>
            <Select
              autoComplete="educandusRoles"
              placeholder="Selecione um ou mais "
              value={selectedRoles}
              options={roles.map(item => ({
                value: item.id,
                label: item.name
              }))}
              isMulti
              onChange={changeRole}
            />
          </CInputGroup>
        </CCol>
      )}
    </CRow>
  );
};

export default StatisticsAccessFilter;
